<div class="cesion-portal">

  @if (cargando && !estado) {
    <div class="cp-cargando">
      <span class="material-symbols-outlined mat-spin">progress_activity</span>
      <div class="subtitulo-simpli2">Revisando el estado de cesión de tus facturas…</div>
    </div>
  }

  @if (!cargando && errorCarga && !estado) {
    <div class="error-msg cp-aviso">
      <span class="material-symbols-outlined">error</span>
      <div>{{errorCarga}}</div>
    </div>
    <div class="btn-simpli-container cp-botones">
      <button class="secondary-button" mat-flat-button (click)="cargar()">Reintentar</button>
    </div>
  }

  @if (estado) {

    <!-- Título + resumen por estado: como «Resumen de tus facturas por ceder» -->
    <div class="cp-encabezado">
      <h2 class="titulo-simpli2">Resumen de tus facturas por ceder</h2>
      <button class="cp-link" (click)="actualizar()" [disabled]="!!ejecutando" matTooltip="Volver a consultar el estado">
        <span class="material-symbols-outlined">refresh</span><span class="cp-link-texto">Actualizar</span>
      </button>
    </div>

    @if (estado.resumen.por_estado.length) {
      <div class="cp-resumen">
        @for (e of estado.resumen.por_estado; track e.estado) {
          <span class="cp-resumen-item">
            <span class="material-symbols-outlined cp-punto" [ngClass]="claseEstado(e.estado)">circle</span>
            {{e.etiqueta}}: <strong>{{e.cantidad}}</strong>
          </span>
        }
      </div>
    }

    <!-- Lo que está pasando ahora -->
    @if (buscando) {
      <div class="info-msg cp-aviso">
        <span class="material-symbols-outlined mat-spin">progress_activity</span>
        <div>Buscando tus documentos en el SII… Puede tardar unos minutos. Puedes quedarte en esta pantalla: se actualiza sola.</div>
      </div>
    } @else if (cediendo && !sondeoDetenido) {
      <div class="info-msg cp-aviso">
        <span class="material-symbols-outlined mat-spin">progress_activity</span>
        <div>Cediendo tus facturas en el SII… Esta pantalla se actualiza sola.</div>
      </div>
    }

    @if (aviso) {
      <div class="cp-aviso" [ngClass]="claseAviso(aviso.tipo)">
        <span class="material-symbols-outlined">{{ aviso.tipo === 'ok' ? 'check_circle' : (aviso.tipo === 'error' ? 'error' : 'info') }}</span>
        <div>{{aviso.texto}}</div>
        <button class="cp-cerrar" (click)="aviso = null" aria-label="Cerrar aviso"><span class="material-symbols-outlined">close</span></button>
      </div>
    }

    @if (bloqueadas.length) {
      <div class="warning-msg cp-aviso">
        <span class="material-symbols-outlined">info</span>
        <div>
          <div>Estas facturas no se incluyeron:</div>
          <ul class="cp-lista">
            @for (b of bloqueadas; track b.documento_id) {
              <li>Factura N° {{b.folio}}: {{b.mensaje}}</li>
            }
          </ul>
        </div>
      </div>
    }

    @if (rechazados.length) {
      <div class="error-msg cp-aviso">
        <span class="material-symbols-outlined">error</span>
        <div>
          <div>Estos archivos no se pudieron usar:</div>
          <ul class="cp-lista">
            @for (a of rechazados; track a.nombre) {
              <li>
                <strong>{{a.nombre}}</strong>@if (a.folio) { (factura N° {{a.folio}})}:
                @for (e of a.errores; track $index) { <span>{{e.mensaje}} </span> }
              </li>
            }
          </ul>
        </div>
      </div>
    }

    @if (todasCedidas) {
      <div class="success-msg cp-aviso">
        <span class="material-symbols-outlined">check_circle</span>
        <div>Todas tus facturas están cedidas a Simpli. Te avisaremos cuando la operación avance.</div>
      </div>
    }

    <!-- Facturas: escritorio (tabla del portal) -->
    <div class="table-responsive-simpli add_factoring cp-escritorio">
      <table mat-table [dataSource]="documentosPagina" multiTemplateDataRows>
        <ng-container matColumnDef="factura">
          <th mat-header-cell *matHeaderCellDef> N° Factura </th>
          <td mat-cell *matCellDef="let d">
            <input class="no-input" readonly value="{{d.folio}}">
          </td>
        </ng-container>
        <ng-container matColumnDef="deudor">
          <th mat-header-cell *matHeaderCellDef> Deudor </th>
          <td mat-cell *matCellDef="let d" matTooltip="{{d.deudor}}">
            <input class="no-input" readonly value="{{d.deudor}}">
          </td>
        </ng-container>
        <ng-container matColumnDef="rut">
          <th mat-header-cell *matHeaderCellDef> RUT </th>
          <td mat-cell *matCellDef="let d">
            <input class="no-input" readonly value="{{d.rut_deudor}}">
          </td>
        </ng-container>
        <ng-container matColumnDef="monto">
          <th mat-header-cell *matHeaderCellDef> Monto </th>
          <td mat-cell *matCellDef="let d">
            <input class="no-input" readonly value="${{formatMoney(d.monto)}}">
          </td>
        </ng-container>
        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef> Estado </th>
          <td mat-cell *matCellDef="let d">
            <div class="cp-estado" [ngClass]="claseEstado(d.estado)">
              <span class="material-symbols-outlined" [class.mat-spin]="d.estado === 'CEDIENDO'">{{iconoEstado(d.estado)}}</span>
              <span>{{d.estado_label}}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="detalle">
          <th mat-header-cell *matHeaderCellDef> Detalle </th>
          <td mat-cell *matCellDef="let d">
            <button class="cp-expandir" (click)="alternarDetalle(d)"
              [attr.aria-expanded]="detalleAbierto === d.documento_factura_id"
              [matTooltip]="detalleAbierto === d.documento_factura_id ? 'Ocultar detalle' : 'Ver detalle'">
              <span class="material-symbols-outlined">{{ detalleAbierto === d.documento_factura_id ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
            </button>
          </td>
        </ng-container>

        <!-- Fila expandible: mensaje, hitos, errores del AEC y «Consultar al SII» -->
        <ng-container matColumnDef="expandido">
          <td mat-cell *matCellDef="let d" [attr.colspan]="columnas.length" class="cp-celda-detalle">
            @if (detalleAbierto === d.documento_factura_id) {
              <ng-container *ngTemplateOutlet="detalleFactura; context: { $implicit: d }"></ng-container>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnas"></tr>
        <tr mat-row *matRowDef="let d; columns: columnas;" class="cp-fila"
          [class.cp-fila-abierta]="detalleAbierto === d.documento_factura_id"></tr>
        <tr mat-row *matRowDef="let d; columns: ['expandido']" class="cp-fila-detalle"
          [class.cp-oculta]="detalleAbierto !== d.documento_factura_id"></tr>
      </table>
    </div>

    <!-- Facturas: responsive (mismas cajas que `cliente-new-responsive`) -->
    <div class="cp-movil">
      @for (d of documentosPagina; track d.documento_factura_id) {
        <div class="box-factura">
          <div class="container-label-res"><mat-label class="left-label">N° Factura:</mat-label><mat-label class="right-label">{{d.folio}}</mat-label></div>
          <div class="container-label-res"><mat-label class="left-label">Deudor:</mat-label><mat-label class="right-label">{{d.deudor}}</mat-label></div>
          <div class="container-label-res"><mat-label class="left-label">RUT:</mat-label><mat-label class="right-label">{{d.rut_deudor}}</mat-label></div>
          <div class="container-label-res"><mat-label class="left-label">Monto:</mat-label><mat-label class="right-label">${{formatMoney(d.monto)}}</mat-label></div>
          <div class="container-label-res">
            <mat-label class="left-label">Estado:</mat-label>
            <mat-label class="right-label cp-estado cp-estado-derecha" [ngClass]="claseEstado(d.estado)">
              <span class="material-symbols-outlined" [class.mat-spin]="d.estado === 'CEDIENDO'">{{iconoEstado(d.estado)}}</span>
              {{d.estado_label}}
            </mat-label>
          </div>
          <ng-container *ngTemplateOutlet="detalleFactura; context: { $implicit: d }"></ng-container>
        </div>
      }
    </div>

    @if (documentos.length > porPagina) {
      <div class="cp-paginacion">
        <numbered-pagination [pageSize]="porPagina" [totalCount]="documentos.length" [index]="paginaActual" (page)="cambiarPagina($event)"></numbered-pagination>
      </div>
    }

    <!-- Clave tributaria de la empresa: hace falta para ceder -->
    @if (!tieneClaveSii && (paraCeder.length || mostrarCertificado || mostrarSubir)) {
      <div class="card-simpli-cesion cp-tarjeta">
        <mat-label class="label-interno">Clave tributaria de la empresa</mat-label>
        <div class="subtitulo-simpli2">Para ceder en el SII necesitamos la clave tributaria (SII) de la empresa. La validamos con el SII y la guardamos cifrada.</div>
        <div class="cp-clave">
          <mat-form-field appearance="fill" class="cp-clave-campo">
            <mat-label>Clave SII de la empresa</mat-label>
            <input matInput type="password" autocomplete="off" [(ngModel)]="claveSii" (keyup.enter)="guardarClave()" [disabled]="ejecutando === 'clave'">
            @if (claveIncorrecta) {
              <mat-hint class="cp-error-campo">La clave no es correcta según el SII. Revísala e intenta de nuevo.</mat-hint>
            }
          </mat-form-field>
          <button class="primary-button" mat-flat-button (click)="guardarClave()" [disabled]="!claveSii || !!ejecutando">
            @if (ejecutando === 'clave') {
              <span class="material-symbols-outlined mat-spin">progress_activity</span>
            } @else {
              Validar y guardar
            }
          </button>
        </div>
      </div>
    }

    <!-- Cómo conseguir los documentos para ceder -->
    @if (!enCurso && (mostrarCertificado || mostrarSubir)) {
      <div class="cp-metodos">
        <mat-label class="label-interno">Para ceder necesitamos el AEC de cada factura</mat-label>
        <ul class="cp-lista subtitulo-simpli2">
          @if (mostrarCertificado) {
            <li>
              <strong>Con tu certificado digital</strong> buscamos tus facturas y su AEC en el SII. Después las cedes a Simpli con un clic.
              @if (!tieneCertificado) { <strong>Primero carga tu certificado.</strong> }
            </li>
          }
          @if (mostrarSubir) {
            <li><strong>Si ya generaste el AEC</strong> en tu facturador, súbelo aquí (archivos .xml).</li>
          }
        </ul>
        <input #inputAec type="file" accept=".xml,text/xml,application/xml" multiple hidden (change)="alElegirArchivos($event)">
        @if (archivos.length) {
          <ul class="cp-archivos">
            @for (f of archivos; track f.name) {
              <li>
                <span class="material-symbols-outlined">description</span>
                <span class="cp-archivo-nombre">{{f.name}}</span>
                <button class="cp-cerrar" (click)="quitarArchivo(f)" [disabled]="!!ejecutando" aria-label="Quitar archivo"><span class="material-symbols-outlined">close</span></button>
              </li>
            }
          </ul>
          <button class="cp-link" (click)="elegirArchivos()" [disabled]="!!ejecutando">
            <span class="material-symbols-outlined">add_circle</span><span class="cp-link-texto">Agregar otro archivo</span>
          </button>
        }
      </div>
    }

    <!-- Confirmación de la cesión -->
    @if (confirmandoCesion && paraCeder.length && !cediendo) {
      <div class="warning-msg cp-aviso cp-confirmacion">
        <span class="material-symbols-outlined">warning</span>
        <div>Vas a ceder <strong>{{paraCeder.length}} factura(s)</strong> a Simpli en el SII. Una vez cedidas no se puede deshacer. ¿Continuar?</div>
      </div>
    }

    <!-- Acciones: píldoras abajo a la derecha, como «Facturas reemitidas» / «Continuar cediendo» -->
    @if (hayAcciones) {
      <div class="btn-simpli-container cp-botones">
        @if (confirmandoCesion && paraCeder.length && !cediendo) {
          <button class="secondary-button" mat-flat-button (click)="confirmandoCesion = false" [disabled]="!!ejecutando">Cancelar</button>
          <button class="primary-button" mat-flat-button (click)="ceder()" [disabled]="!!ejecutando">
            @if (ejecutando === 'ceder_aec') {
              <span class="material-symbols-outlined mat-spin">progress_activity</span>
            } @else {
              Sí, ceder
            }
          </button>
        } @else {
          @if (mostrarSubir && !enCurso) {
            @if (archivos.length) {
              <button [ngClass]="principal === 'subir' ? 'primary-button' : 'secondary-button'" mat-flat-button (click)="subirAec()" [disabled]="!!ejecutando">
                @if (ejecutando === 'subir_aec') {
                  <span class="material-symbols-outlined mat-spin">progress_activity</span>
                } @else {
                  Subir {{archivos.length}} AEC
                }
              </button>
            } @else {
              <button [ngClass]="principal === 'subir' ? 'primary-button' : 'secondary-button'" mat-flat-button (click)="elegirArchivos()" [disabled]="!!ejecutando">
                Subir mis AEC
              </button>
            }
          }
          @if (mostrarCertificado && !enCurso) {
            @if (!tieneCertificado) {
              <button [ngClass]="principal === 'certificado' ? 'primary-button' : 'secondary-button'" mat-flat-button (click)="cargarCertificado()" [disabled]="!!ejecutando">
                Cargar certificado
              </button>
            } @else if (paraBuscar.length) {
              <button [ngClass]="principal === 'buscar' ? 'primary-button' : 'secondary-button'" mat-flat-button (click)="buscarDocumentos()" [disabled]="!!ejecutando">
                @if (ejecutando === 'buscar_dte') {
                  <span class="material-symbols-outlined mat-spin">progress_activity</span>
                } @else {
                  Buscar mis documentos en el SII
                }
              </button>
            }
          }
          @if (paraCeder.length && !cediendo) {
            <button [ngClass]="principal === 'ceder' ? 'primary-button' : 'secondary-button'" mat-flat-button (click)="pedirConfirmacionCesion()" [disabled]="!!ejecutando">
              Ceder {{paraCeder.length}} factura(s)
            </button>
          }
        }
      </div>
    }
  }
</div>

<!-- El detalle de una factura: el mismo en la fila expandible y en la caja responsive -->
<ng-template #detalleFactura let-d>
  <div class="cp-detalle">
    @if (d.mensaje?.titulo || d.mensaje?.detalle) {
      <div class="cp-detalle-mensaje">
        @if (d.mensaje.titulo) { <strong>{{d.mensaje.titulo}}.</strong> }
        @if (d.mensaje.detalle) { {{d.mensaje.detalle}} }
      </div>
    }

    @if (d.hitos?.length) {
      <ol class="cp-hitos">
        @for (h of d.hitos; track h.clave) {
          <li class="cp-hito" [ngClass]="'cp-hito-' + h.estado">
            <div class="cp-hito-circulo">
              <span class="material-symbols-outlined">{{iconoHito(h)}}</span>
              @if (h.estado === 'hecho') {
                <span class="material-symbols-outlined cp-hito-check" aria-label="Hecho">check_circle</span>
              }
            </div>
            <div class="cp-hito-texto">
              <span class="cp-hito-titulo">{{h.titulo}}</span>
              @if (h.fecha) { <span class="cp-hito-fecha">{{formatearFecha(h.fecha)}}</span> }
            </div>
          </li>
        }
      </ol>
    }

    @if (d.aec?.errores?.length) {
      <ul class="cp-lista cp-detalle-errores">
        @for (e of d.aec.errores; track $index) {
          <li>{{e.mensaje}}</li>
        }
      </ul>
    }

    @if (d.acciones.includes('validar')) {
      <div class="cp-detalle-acciones">
        <button class="secondary-button cp-btn-chico" mat-flat-button (click)="validar(d)" [disabled]="!!ejecutando"
          matTooltip="Preguntar al SII cómo quedó la cesión de esta factura">
          @if (validandoId === d.documento_factura_id) {
            <span class="material-symbols-outlined mat-spin">progress_activity</span>
          } @else {
            Consultar al SII
          }
        </button>
      </div>
    }
  </div>
</ng-template>
